// frontend/components/Composite/index.js
export { default as Hero } from './Hero';
export { default as CodeBlock } from './CodeBlock';
export { default as Headline } from './Headline';
export { default as IconBullets } from './IconBullets';
export { default as FeatureBlock } from './FeatureBlock';
export { default as Highlight } from './Highlight';
export { default as Teaser } from './Teaser';
export { default as Logos } from './Logos';
export { default as StandaloneCta } from './StandaloneCta';
export { default as JoinUs } from './JoinUs';
export { default as ToolsShowcase } from './ToolsShowcase';
export { default as Video } from './Video';
export { default as CardGrid } from './CardGrid';
export { default as CarouselImage } from './CarouselImage';
export { default as ImageText } from './ImageText';
export { default as ThumbnailGallery } from './ThumbnailGallery';
export { default as ManualTable } from './ManualTable';
export { default as Spreadsheet } from './Spreadsheet';
export { default as FAQ } from './FAQ';
export { default as Footnotes } from './Footnotes';